export const CompanyDocuments = -5;
export const MyDocuments = -3;
export const TeamDocuments = -2;
export const AllDocuments = -1;
